import { BaseRequest } from 'src/app/tools/models/dtos/base-request';
import { RoleProductQuota } from '../entities/role-product-quota';


export class RoleProductQuotasRequest extends BaseRequest {
    roleProductQuotas : RoleProductQuota[];
}
